import firebase from "firebase/app";
import { getPlatforms } from "@ionic/react";

const platforms = getPlatforms();
const isAndroid = platforms.includes("android");
const isIos = platforms.includes("ios");

export const firebaseConfig = {
  apiKey: "AIzaSyAJiQDsW8req1tKBNcjMeB3clQmge3wHCg",
  authDomain: "ax-b2c-test.firebaseapp.com",
  projectId: "ax-b2c-test",
  storageBucket: "ax-b2c-test.appspot.com",
  messagingSenderId: "712992810397",
  appId: "1:712992810397:web:b3074506d053ce6ecafb74",
  measurementId: "G-ZDRLDZFVS8",
};

export function formatError(error: string) {
  if (error.includes("auth/")) {
    const splitted = error.split("/");
    if (splitted && splitted.length === 2) {
      alert(splitted.pop()?.split("-").join(" "));
      return;
    }
  }
  // alert(error);

  console.error("Firebase - 28", error);
}

export function initializeApp() {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.app();
  }
}
let db: any = null;
export async function fireStoreDbInstance() {
  if ((window as any).Firestore) {
    if (db === null) {
      db = await (window as any).Firestore.initialise(firebaseConfig);
    }
    return db;
  } else {
    return await firebase.firestore();
  }
}

export * from "./auth";
export * from "./firestore";
export * from "./storage";
